import { landSlideAttributes } from "../../contexts/krFormContext";

export class CalcField {
    static hasKoDlugoscParams = (attr: landSlideAttributes) => {
        return Boolean(attr.oS_DLUGOSC && attr.sG_WYSOKOSC && attr?.sG_NACHYLENIE);
    }

    static koDlugosc = (attr: landSlideAttributes) => {
        if (attr && this.hasKoDlugoscParams(attr)) {
            // @ts-ignore
            var calc = (attr.oS_DLUGOSC - (attr?.sG_WYSOKOSC / Math.tan(attr?.sG_NACHYLENIE * (Math.PI / 180))));
            return this.toIntValue(calc);
        }
        return attr.kO_DLUGOSC;
    }

    static hasOsNachylenieParams = (attr: landSlideAttributes) => {
        return Boolean(attr.oS_DLUGOSC && attr.oS_ROZPIETOSC);
    }

    static osNachylenie = (attr: landSlideAttributes) => {
        if (attr && this.hasOsNachylenieParams(attr)) {
            // @ts-ignore
            var calc = Math.atan(attr.oS_ROZPIETOSC / attr.oS_DLUGOSC) * (180 / Math.PI);
            return this.toIntValue(calc);
        }
        return attr.oS_NACHYLENIE;
    }

    static hasKoNachylenieParams = (attr: landSlideAttributes) => {
        return Boolean(attr.oS_DLUGOSC && attr.sG_WYSOKOSC && attr.kO_DLUGOSC && attr.oS_NACHYLENIE);
    }

    static koNachylenie = (attr: landSlideAttributes) => {
        if (attr && this.hasKoNachylenieParams(attr)) {
            // @ts-ignore
            var calc = Math.atan(((Math.tan(attr.oS_NACHYLENIE as number * (Math.PI / 180)) * attr.oS_DLUGOSC) - attr.sG_WYSOKOSC) / attr.kO_DLUGOSC) * (180 / Math.PI);
            return this.toIntValue(calc);
        }
        return attr.kO_NACHYLENIE;
    }

    static hasStNachylenieParams = (attr: landSlideAttributes) => {
        return Boolean(attr.sT_DLUGOSC && attr.sT_WYSOKOSC);
    }

    static stNachylenie = (attr: landSlideAttributes) => {
        if (attr && this.hasStNachylenieParams(attr)) {
            // @ts-ignore
            var calc = Math.asin(attr.sT_WYSOKOSC / attr.sT_DLUGOSC) * (180 / Math.PI);
            return this.toIntValue(calc);
        }
        return attr.sT_NACHYLENIE;
    }

    static hasOsRozpietoscParams = (attr: landSlideAttributes) => {
        return Boolean(attr.oS_WYS_MAKS && attr.oS_WYS_MIN);
    }

    static osRozpietosc = (attr: landSlideAttributes) => {
        if (attr && this.hasOsRozpietoscParams(attr)) {
            // @ts-ignore
            var calc = attr.oS_WYS_MAKS - attr.oS_WYS_MIN;
            return this.toIntValue(calc);
        }
        return attr.oS_ROZPIETOSC;
    }

    static haArea = (value: number | undefined | null) => {
        if (!value) { return null }
        var val = (value / 10000) as number + Number.EPSILON;
        if (value < 95) {
            return ((val * 100) / 100).toFixed(3);
        }
        else {
            return Math.round(val * 100) / 100
        }
    }

    static toRound(value: any, decimalPlaces: number) {
        if (value !== null && value !== undefined && value !== "") {
            return Number(Math.round(parseFloat(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces);
        }
        return value;
    }

    static toIntValue(calc: any) {
        if (calc !== null && calc !== undefined && calc !== "") {
            return Number.isNaN(calc) ? null : Math.round((calc));
        }
        return null;
    }
}
